import { nestableLevel, type Container, type Nestable } from './Container';
import type { Unparser } from './Unparser';

export abstract class Item implements Nestable {
  start?: number;
  parent?: Container;

  constructor(opts?: { start?: number; parent?: Container }) {
    this.start = opts?.start;
    this.parent = opts?.parent;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  toJSON(opts?: { compact?: boolean }): object {
    return {
      type: this.constructor.name,
      start: this.start,
      parent: this.parent?.id
    };
  }

  get level(): number {
    return nestableLevel(this);
  }

  // Return true if the item would be unparsed with a brace ('}') at the end
  // or has some other self-terminating structure.
  //
  // Examples of self-terminating items:
  // - GroupStatement (ends with a brace)
  // - EdgeStatement (parsed with a required line break)
  //
  // This is used to decide whether to add a semicolon when outputting in compact format.
  // eslint-disable-next-line @typescript-eslint/class-literal-property-style
  get selfTerminating(): boolean {
    return false;
  }

  abstract unparse(u: Unparser): void;
}
